module.exports = __webpack_public_path__ + "img/img010.d5934d9e.png";